import React from 'react';
import { useDispatch } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';

import {
  Box,
  Grid,
} from '@material-ui/core';

import {
  setMessage,
} from '../../store/authSlice';

import {
  updateCardInList,
  removeCardFromList,
  patchPaymentCardSession,
} from '../../store/widgetSlice';

import BaseButton from './BaseButton';
import CardResults from './CardResults';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    '& > *': {
      padding: [theme.spacing(2)],
    },
    maxWidth: 700,
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  box: {
    marginLeft: 'auto',
    marginRight: 'auto',
    width: 500,
    maxWidth: '100%',
  },
  actions: {
    marginTop: 10,
    paddingTop: 20,
    flexGrow: 1,
  },
  action: {
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    width: '100%',
    marginBottom: theme.spacing(2),

    '&:last-child': {
      marginBottom: theme.spacing(1),
    },

    [theme.breakpoints.up('sm')]: {
      marginBottom: 0,
    },
  },
}));

export default function CardEditor({ card, admin }) {
  const classes = useStyles();
  const dispatch = useDispatch();

  const updateCard = (updatedCard) => {
    dispatch(updateCardInList({ card: updatedCard }));
  };

  const sendToAdmin = () => {
    dispatch(patchPaymentCardSession({ ...card, status: 'A' }))
      .unwrap()
      .then(() => {
        dispatch(removeCardFromList({ card }));
        dispatch(setMessage({ message: 'Card session updated successfully', severity: 'success' }));
      })
      .catch(() => {
        dispatch(setMessage({ message: 'Card session could not be updated', severity: 'error' }));
      });
  };

  const sendToReview = () => {
    dispatch(patchPaymentCardSession({ ...card, status: 'R' }))
      .unwrap()
      .then(() => {
        dispatch(removeCardFromList({ card }));
        dispatch(setMessage({ message: 'Card session updated successfully', severity: 'success' }));
      })
      .catch(() => {
        dispatch(setMessage({ message: 'Card session could not be updated', severity: 'error' }));
      });
  };

  const failCheck = () => {
    dispatch(patchPaymentCardSession({ ...card, status: 'F' }))
      .unwrap()
      .then(() => {
        dispatch(removeCardFromList({ card }));
        dispatch(setMessage({ message: 'Card session updated successfully', severity: 'success' }));
      })
      .catch(() => {
        dispatch(setMessage({ message: 'Card session could not be updated', severity: 'error' }));
      });
  };

  const passCheck = () => {
    dispatch(patchPaymentCardSession({ ...card, status: 'C' }))
      .unwrap()
      .then(() => {
        dispatch(removeCardFromList({ card }));
        dispatch(setMessage({ message: 'Card session updated successfully', severity: 'success' }));
      })
      .catch(() => {
        dispatch(setMessage({ message: 'Card session could not be updated', severity: 'error' }));
      });
  };

  return (
    <>
      <Box p={2} className={classes.box}>
        <CardResults admin={admin} session={card} editable onSessionChange={updateCard} showGuestData />
        <Grid container className={classes.actions}>
          {admin
            ? (
              <Grid item sm={4} className={classes.action}>
                <BaseButton fullWidth onClick={sendToReview}>Send to Review</BaseButton>
              </Grid>
            )
            : (
              <Grid item sm={4} className={classes.action}>
                <BaseButton fullWidth onClick={sendToAdmin}>Send to Admin</BaseButton>
              </Grid>
            )}
          <Grid item sm={4} className={classes.action}>
            <BaseButton fullWidth onClick={failCheck}>Fail Check</BaseButton>
          </Grid>
          <Grid item sm={4} className={classes.action}>
            <BaseButton fullWidth onClick={passCheck}>Pass Check</BaseButton>
          </Grid>
        </Grid>
      </Box>
    </>
  );
}
